export function isExternalUrl(href: string): boolean {
  return /^https?:\/\//.test(href);
}

export function linkTargetProps(href: string): { target?: string; rel?: string } {
  return isExternalUrl(href) ? { target: '_blank', rel: 'noopener noreferrer' } : {};
}
